import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, VerifyEmail } from 'types';
import { client } from 'utils/api-client';

const verifyEmail = (payload: VerifyEmail): Promise<AxiosResponse<string>> => {
  return client.post('/auth/verify-email/', payload);
};

export default function useVerifyEmail(): UseMutationResult<
  AxiosResponse<string>,
  AxiosError<ErrorMessage>,
  VerifyEmail
> {
  return useMutation(verifyEmail);
}
